<template>
    <v-app>
        <v-main>
            <div style="margin:auto !important; max-width:800px; padding: 10px 0">
                <div v-if="submitted == true">Your form has been submitted.</div>
                <div v-else-if="linkInvalid == true || urlValuesCheck == false">
                    Invalid Link.
                    <br />Inform your link provider or contact info@accisure.co.za
                </div>
                <div v-else-if="showForm == true && linkInvalid == false">
                    <v-form
                        ref="entityForm"
                        v-model="isValid"
                    >
                        <v-card-text>
                            <v-container
                                class="pb-0"
                                fluid
                            >
                                <v-row class="pb-0">
                                    <v-col cols="12">
                                        <h4>
                                            Representative: {{entity.representativeName}}
                                            <br />
                                            Product: {{entity.representativeProductName}}
                                            <br />
                                            Dependants: {{entity.subscriptionDependantsCount}}
                                            <br />
                                            Amount: R{{entity.subscriptionAmount.toFixed(2)}}
                                        </h4>
                                    </v-col>
                                    <v-col cols="12">
                                        <h4>Main Member:</h4>
                                        <v-file-input
                                            :disabled="isLoading"
                                            :rules="[requiredRule]"
                                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                                            label="Identity Document"
                                            placeholder="Set Identity Document"
                                            ref="identityDocumentFileInput"
                                            v-model="identityDocument"
                                        ></v-file-input>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Titles"
                                            v-model="entity.titles"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Initials"
                                            v-model="entity.initials"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Surname"
                                            v-model="entity.surname"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading"
                                            :items="genders"
                                            :rules="[requiredRule]"
                                            clearable
                                            item-text="name"
                                            item-value="value"
                                            label="Gender"
                                            v-model="entity.gender"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[validRSAID,requiredRule,lengthRule(50)]"
                                            label="Identity Number"
                                            v-model="entity.identityNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Cell Number"
                                            v-model="entity.cellNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Work Number"
                                            v-model="entity.workNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Email"
                                            v-model="entity.email"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(100)]"
                                            label="Address"
                                            v-model="entity.address"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(100)]"
                                            label="City"
                                            v-model="entity.city"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(100)]"
                                            label="Postal Address"
                                            v-model="entity.postalAddress"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Postal Code"
                                            v-model="entity.postalCode"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(250)]"
                                            label="Allergies"
                                            v-model="entity.allergies"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Bank Account Number"
                                            v-model="entity.bankAccountNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Bank Name"
                                            v-model="entity.bankName"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Bank Branch Code"
                                            v-model="entity.bankBranchCode"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading"
                                            :items="accisureDebitOrderDates"
                                            :rules="[requiredRule]"
                                            clearable
                                            item-text="name"
                                            item-value="value"
                                            label="Debit Order Date"
                                            v-model="entity.accisureDebitOrderDate"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            min-width="290px"
                                            offset-y
                                            transition="scale-transition"
                                            v-model="dateMenu"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    :rules="[requiredRule]"
                                                    label="Commencement Date"
                                                    prepend-icon="mdi-calendar-month"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="entity.commencementDate"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                @input="dateMenu = false"
                                                color="secondary"
                                                v-model="entity.commencementDate"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <template v-if="entity.subscriptionDependantsCount>0">
                                        <h4>Dependant 1:</h4>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Initials"
                                                v-model="entity.dependant1Initials"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Surname"
                                                v-model="entity.dependant1Surname"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-select
                                                :disabled="isLoading"
                                                :items="genders"
                                                :rules="[requiredRule]"
                                                clearable
                                                item-text="name"
                                                item-value="value"
                                                label="Gender"
                                                v-model="entity.dependant1Gender"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[validRSAID,requiredRule,lengthRule(50)]"
                                                label="Identity Number"
                                                v-model="entity.dependant1IdentityNumber"
                                            ></v-text-field>
                                        </v-col>
                                    </template>
                                    <template v-if="entity.subscriptionDependantsCount>1">
                                        <h4>Dependant 2:</h4>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Initials"
                                                v-model="entity.dependant2Initials"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Surname"
                                                v-model="entity.dependant2Surname"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                :disabled="isLoading"
                                                :items="genders"
                                                :rules="[requiredRule]"
                                                clearable
                                                item-text="name"
                                                item-value="value"
                                                label="Gender"
                                                v-model="entity.dependant2Gender"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[validRSAID,requiredRule,lengthRule(50)]"
                                                label="Identity Number"
                                                v-model="entity.dependant2IdentityNumber"
                                            ></v-text-field>
                                        </v-col>
                                    </template>

                                    <template v-if="entity.subscriptionDependantsCount>2">
                                        <h4>Dependant 3:</h4>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Initials"
                                                v-model="entity.dependant3Initials"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Surname"
                                                v-model="entity.dependant3Surname"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                :disabled="isLoading"
                                                :items="genders"
                                                :rules="[requiredRule]"
                                                clearable
                                                item-text="name"
                                                item-value="value"
                                                label="Gender"
                                                v-model="entity.dependant3Gender"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[validRSAID,requiredRule,lengthRule(50)]"
                                                label="Identity Number"
                                                v-model="entity.dependant3IdentityNumber"
                                            ></v-text-field>
                                        </v-col>
                                    </template>
                                    <template v-if="entity.subscriptionDependantsCount>3">
                                        <h4>Dependant 4:</h4>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Initials"
                                                v-model="entity.dependant4Initials"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Surname"
                                                v-model="entity.dependant4Surname"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                :disabled="isLoading"
                                                :items="genders"
                                                :rules="[requiredRule]"
                                                clearable
                                                item-text="name"
                                                item-value="value"
                                                label="Gender"
                                                v-model="entity.dependant4Gender"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[validRSAID,requiredRule,lengthRule(50)]"
                                                label="Identity Number"
                                                v-model="entity.dependant4IdentityNumber"
                                            ></v-text-field>
                                        </v-col>
                                    </template>
                                    <template v-if="entity.subscriptionDependantsCount>4">
                                        <h4>Dependant 5:</h4>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Initials"
                                                v-model="entity.dependant5Initials"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule,lengthRule(50)]"
                                                label="Surname"
                                                v-model="entity.dependant5Surname"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                :disabled="isLoading"
                                                :items="genders"
                                                :rules="[requiredRule]"
                                                clearable
                                                item-text="name"
                                                item-value="value"
                                                label="Gender"
                                                v-model="entity.dependant5Gender"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[validRSAID,requiredRule,lengthRule(50)]"
                                                label="Identity Number"
                                                v-model="entity.dependant5IdentityNumber"
                                            ></v-text-field>
                                        </v-col>
                                    </template>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="end"
                                    no-gutters
                                >
                                    <v-col cols="12">
                                        <v-checkbox v-model="entity.agreedToTermsAndConditions">
                                            <template v-slot:label>
                                                <div>
                                                    I agree to the
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <a
                                                                @click.stop
                                                                href="http://app.erafsolutions.co.za/Terms%20and%20Conditions%20-%20Accisure%20(Execution%20Version)%2011052020.pdf"
                                                                target="_blank"
                                                                v-on="on"
                                                            >Terms and Conditions</a>
                                                        </template>
                                                        Opens in new window
                                                    </v-tooltip>.
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-btn
                                        :disabled="(isLoading && !isSaving) || entity.agreedToTermsAndConditions !== true"
                                        :loading="isSaving"
                                        @click="getSignature"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >Sign Form</v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                </div>
                <div v-else>
                    <v-skeleton-loader type="list-item-avatar, list-item-three-line,article, actions"></v-skeleton-loader>
                </div>
            </div>
            <v-snackbar
                :color="notifyColor"
                :timeout="15000"
                top
                v-model="notifyShow"
            >
                {{ notifyMessage }}
                <template v-slot:action="{ attrs }">
                    <v-btn
                        @click="notifyShow = false"
                        class="text-none"
                        icon
                        v-bind="attrs"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-snackbar>
            <v-dialog
                eager
                persistent
                v-model="showSignatureForm"
                width="500px"
            >
                <v-card>
                    <v-card-title>Signature</v-card-title>
                    <v-card-text
                        class="ma-0 pa-0"
                        style="text-align:center;background-color:rgb(230,230,230)"
                    >
                        <canvas ref="signaturecanvas"></canvas>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="isLoading"
                            @click="submitSignature"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Submit</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="resizeCanvas"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Clear</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="showSignatureForm = false"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-main>
    </v-app>
</template>

<script>
import SubscribeFormSubmission from "../models/SubscribeFormSubmission.model";
import SignaturePad from "signature_pad";

export default {
    props: {},
    components: {},
    data() {
        return {
            accisureDebitOrderDates: [
                { name: "1st", value: 1 },
                { name: "16th", value: 16 },
                { name: "26th", value: 26 }
            ],
            genders: [
                { name: "Female", value: 2 },
                { name: "Male", value: 1 }
            ],
            signaturePadOptions: {
                penColor: "rgb(0,0,0)",
                backgroundColor: "rgba(255,255,255,0)"
            },
            entity: new SubscribeFormSubmission(),
            showForm: false,
            linkInvalid: false,
            submitted: false,
            showSignatureForm: false,

            signatureCanvas: null, //this.$refs.signaturecanvas,
            signaturePad: null, //new SignaturePad(this.$refs.signaturecanvas),

            repcode: null,
            productcode: null,
            cell: null,
            cardnumber: null,
            signedbyuserid: null,

            dateMenu: false,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
                validRSAID: v => {
                var invalidId = "Invalid RSA ID";
                if (!v || v.length != 13) return invalidId;

                var idNumbers;
                try {
                    idNumbers = v.split("").map(x => parseInt(x));
                } catch {
                    return invalidId;
                }

                if (idNumbers[10] > 1) return invalidId;

                var evens = [
                    idNumbers[1],
                    idNumbers[3],
                    idNumbers[5],
                    idNumbers[7],
                    idNumbers[9],
                    idNumbers[11]
                ];

                var odds = [
                    idNumbers[0],
                    idNumbers[2],
                    idNumbers[4],
                    idNumbers[6],
                    idNumbers[8],
                    idNumbers[10],
                    idNumbers[12]
                ];

                var evensLuhnSum = evens
                    .map(x => {
                        var d = 2 * x;
                        if (d > 9) {
                            var dstring = d.toString();
                            d = parseInt(dstring[0]) + parseInt(dstring[1]);
                        }
                        return d;
                    })
                    .reduce((a, b) => a + b, 0);

                var oddsSum = odds.reduce((a, b) => a + b, 0);

                return (evensLuhnSum + oddsSum) % 10 == 0 || invalidId;
            },
            identityDocument: null
        };
    },
    mounted: function() {
        this.setFromUrlParameters();
        if (this.urlValuesCheck)
            this.formDetailsLookup(this.repcode, this.productcode, this.cell, this.cardnumber, this.signedbyuserid);
        //new SignaturePad(this.$refs.signaturecanvas);

        this.signatureCanvas = this.$refs.signaturecanvas;
        this.signaturePad = new SignaturePad(
            this.signatureCanvas,
            this.signaturePadOptions
        );
    },
    computed: {
        urlValuesCheck: function() {
            if (this.repcode && this.productcode && this.cell) return true;
            else return false;
        }
    },
    //https://app.erafsolutions.co.za/accisureform?repcode=1&productcode=1&cell=0123456789
    methods: {
        setFromUrlParameters() {
            var p = this.$route.query;
            if (p) {
                this.repcode = p.repcode;
                this.productcode = p.productcode;
                this.cell = p.cell;
                this.cardnumber = p.cardnumber ? p.cardnumber : null;
                this.signedbyuserid = p.signedbyuserid ? p.signedbyuserid : null;
            }
        },
        formDetailsLookup(repcode, productcode, cell, cardnumber, signedbyuserid) {
            this.$store
                .dispatch("subscribeFormSubmissions/validitycheck", {
                    repcode,
                    productcode,
                    cell,
                    cardnumber,
                    signedbyuserid
                })
                .then(
                    result => {
                        this.entity = result.subscribeFormSubmission;
                        this.subscription = result.subscription;
                        this.representative = result.representative;
                        this.representativeProduct =
                            result.representativeProduct;
                        this.showForm = true;
                    },
                    error => {
                        this.notify(error.response.data, "error");
                        this.linkInvalid = true;
                    }
                );
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        validateForm() {
            this.isValid = this.$refs.entityForm.validate();
            return this.isValid;
        },
        resizeCanvas() {
            this.signatureCanvas.width = 400;
            this.signatureCanvas.height = 150;
            this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        },
        getSignature() {
            if (this.validateForm()) {
                this.showSignatureForm = true;
                this.resizeCanvas();
            }
        },
        submitSignature() {
            if (this.signaturePad.isEmpty()) {
                this.notify("Please sign before submitting.", "error");
            } else {
                this.entity.signatureImageBase64 = this.signaturePad.toDataURL();
                this.showSignatureForm = false;
                this.saveEntity();
            }
            //save signature to base64string
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("IdDocument", this.identityDocument);
                formdata.append("Model", JSON.stringify(this.entity));

                this.$store
                    .dispatch("subscribeFormSubmissions/submission", formdata)
                    .then(
                        () => {
                            this.notify("Successfully saved.", "success");
                            this.submitted = true;
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>